import { actionsFactories } from 'store/features/utils';
import { DeeplinkConflictResolveResponse, DeeplinkEntryResponse, DeeplinkLinkAccountResponse } from './types';

export const deeplinkEntry = actionsFactories.createSingleFeatureActionsFactory<
  { token: string },
  DeeplinkEntryResponse
>()('DEEPLINK_ENTRY_REQUEST', 'DEEPLINK_ENTRY_SUCCESS', 'DEEPLINK_ENTRY_FAILURE', 'DEEPLINK_ENTRY_RESET');

export const deeplinkLinkAccount = actionsFactories.createSingleFeatureActionsFactory<
  { client: string; external_user_id: string },
  DeeplinkLinkAccountResponse
>()(
  'DEEPLINK_LINK_ACCOUNT_REQUEST',
  'DEEPLINK_LINK_ACCOUNT_SUCCESS',
  'DEEPLINK_LINK_ACCOUNT_FAILURE',
  'DEEPLINK_LINK_ACCOUNT_RESET',
);

export const deeplinkConflictResolve = actionsFactories.createSingleFeatureActionsFactory<
  { client: string; external_user_id: string; action: 'switch' | 'keep' },
  DeeplinkConflictResolveResponse
>()(
  'DEEPLINK_CONFLICT_RESOLVE_REQUEST',
  'DEEPLINK_CONFLICT_RESOLVE_SUCCESS',
  'DEEPLINK_CONFLICT_RESOLVE_FAILURE',
  'DEEPLINK_CONFLICT_RESOLVE_RESET',
);
